

import axios, { type AxiosResponse } from 'axios'
import { type RootObjectCompletedContracts } from './_models'
import { axiosErrorHandler } from 'app/modules/errors/ApiError'
import { FormsDataQueryResponse } from '../formsdata/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const FORMSDATAS_URL = `${API_URL}/contracts`
const DOCUSIGN_URL = process.env.REACT_APP_DOCUSIGN_BACKEND_URL
const getBase64pdf = async (params: string): Promise<any> => {
  return await axios.get(`${DOCUSIGN_URL}/getPdf/${params}`).then((d: AxiosResponse<any>) => {
    return d.data
  })
}

const getGoogleFolderId = async (params: string,secondparams:string): Promise<any> => {
  return await axios.get(`${DOCUSIGN_URL}/getfoldercreated/${params}/${secondparams}`).then((d: AxiosResponse<any>) => {
    return d.data
  })
}

const postAddUseOfRep = async (data: any): Promise<any> => {
  return await axios.post(`${DOCUSIGN_URL}/create`,data).then((d: AxiosResponse<any>) => {
    return d.data
  })
}

const  createUseOfRepItem = async (arraytosave: any,envelopeId:any): Promise<any> => {
  const data={
    arraytosave:arraytosave,
    envelopeId:envelopeId
  }
  return await axios.post(`${FORMSDATAS_URL}/createitem`,data).then((d: AxiosResponse<any>) => {
    return d.data
  })
}

const getAllCompletedContracts = async (
  fromDate: string,
  toDate: string
): Promise<RootObjectCompletedContracts> => {
  return await axios
    .get(`${DOCUSIGN_URL}/getcompletedcontracts/${fromDate}/${toDate}`)
    .then((d: AxiosResponse<RootObjectCompletedContracts>) => {
      return d.data
    })
}

export const getCurrentWeekContracts = async (): Promise<any> => {
  const today = new Date();
  const day = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const diff = day === 0 ? 0 : day; // si es domingo, diff = 0
  const lastSunday = new Date(today);
  lastSunday.setDate(today.getDate() - diff);

  const formattedDate = lastSunday.toISOString().split('T')[0]; // YYYY-MM-DD

  const response: AxiosResponse<any> = await axios.get(
    `${DOCUSIGN_URL}/weekcompletedcontracts/${formattedDate}/0000-00-00`
  );

  return response.data.folderItems ?? [];
};

const getContractByMatchId = async (matchId: string) => {
  const response: AxiosResponse = await axios.get(
    `${API_URL}/contractstemps/getonewithmatch/${matchId}`
  );
  return response.data;
};

const fetchContractsAndDetails = async () => {
  const contracts = await getCurrentWeekContracts();

  // Filtrar solo los que tienen matchId
  const withMatchId = contracts.filter((c: any) => c.matchId);

  if (withMatchId.length === 0) {
    console.log("⚠️ No hay contratos con matchId esta semana");
    return [];
  }

  // Lanzar todas las segundas llamadas en paralelo
  const details = await Promise.all(
    withMatchId.map((c: any) => getContractByMatchId(c.matchId as string))
  );

  return details;
};


const getAllSentContracts = async (
  
): Promise<RootObjectCompletedContracts> => {
  return await axios
    .get(`${DOCUSIGN_URL}/getsentcontracts`)
    .then((d: AxiosResponse<RootObjectCompletedContracts>) => {
      return d.data
    })
}

const getAllCompletedContractsByEmail = async (
  email: string | undefined,
  fromDate: string,
  toDate: string
): Promise<RootObjectCompletedContracts> => {
  return await axios
    .get(`${DOCUSIGN_URL}/getcompletedcontracts/${email}/${fromDate}/${toDate}`)
    .then((d: AxiosResponse<RootObjectCompletedContracts>) => {
      return d.data
    })
}


// En _requests.js o donde sea que se encuentren tus solicitudes

export const getAllCompletedContractsByEmailAndId = async (email: string, contractId: string, fromDate: string, toDate: string) => {
  const response = await fetch(`/api/contracts?email=${email}&contractId=${contractId}&fromDate=${fromDate}&toDate=${toDate}`);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};


const getBase64DO = async (email: string): Promise<any> => {
  return await axios.get(`${DOCUSIGN_URL}/getfiles/${email}`).then((d: AxiosResponse<any>) => {
    return d.data
  })
}

const updateContracts = async (id: string, contract: any) => {
  return await axios
    .patch(`${FORMSDATAS_URL}/${id}`, contract)
    .then((response: AxiosResponse<FormsDataQueryResponse>) => response.data)
    .catch((error) => {
      axiosErrorHandler(error, 'Error al actualizar ')
    })
}

const updateCon = async (id: string, status: any) => {
  return await axios
    .patch(`${FORMSDATAS_URL}/updatecon/${id}`, { "status": status })
    .then((response: AxiosResponse<FormsDataQueryResponse>) => response.data)
    .catch((error) => {
      axiosErrorHandler(error, 'Error al actualizar ')
    })
}


const updateuofrep = async (id: string) => {
  return await axios
    .patch(`${FORMSDATAS_URL}/updateuof/${id}`)
    .then((response: AxiosResponse<FormsDataQueryResponse>) => response.data)
    .catch((error) => {
      axiosErrorHandler(error, 'Error al actualizar ')
    })
}
export {
  getBase64pdf,
  getAllCompletedContracts,
  getAllCompletedContractsByEmail,
  getBase64DO,
  updateContracts,
  updateCon,
  updateuofrep,
  postAddUseOfRep,
  createUseOfRepItem,
  getGoogleFolderId,
  getAllSentContracts,
  fetchContractsAndDetails
}
